/** @jsxImportSource @emotion/react */
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline'
import MapOutlinedIcon from '@mui/icons-material/MapOutlined'
import { Box, Typography } from '@mui/material'
import DataLayerDetailHeader, { DataLayerDetailHeaderBackButton } from './DataLayerDetailHeader'
import {
  container,
  content,
  header,
  mapPane,
  page,
  side,
  sideInner,
} from '../styles/DataLayerDetailPage.styles'

import { css } from '@emotion/react'

export const DataLayerDetailError = () => {
  return (
    <Box data-testid="risk-data-detail-error" css={page}>
      <Box data-testid="risk-data-detail-error-container" css={container}>
        <Box data-testid="risk-data-detail-error-header" css={header}>
          <DataLayerDetailHeader>
            <DataLayerDetailHeaderBackButton />
          </DataLayerDetailHeader>
        </Box>

        <Box css={content}>
          {/* Left: Map with empty state */}
          <Box css={[mapPane, mapCenter]}>
            <Box css={emptyMapContent}>
              <MapOutlinedIcon css={mapIcon} />
              <Typography variant="body2" color="text.disabled" css={mapTitle}>
                No spatial data available
              </Typography>
              <Typography variant="caption" color="text.disabled" css={mapCaption}>
                Map cannot be displayed for this layer
              </Typography>
            </Box>
          </Box>

          {/* Right: Error panel */}
          <Box css={side}>
            <Box css={sideInner}>
              <Box css={sidePanelCenter}>
                <ErrorOutlineIcon css={errorIcon} />
                <Box>
                  <Typography
                    variant="subtitle1"
                    fontWeight="600"
                    color="text.primary"
                    gutterBottom
                  >
                    Unable to load layer details
                  </Typography>
                  <Typography variant="body2" color="text.secondary" css={messageText}>
                    There was a problem retrieving the data for this layer. Please try again or
                    contact support if the issue persists.
                  </Typography>
                </Box>
                <DataLayerDetailHeaderBackButton />
              </Box>
            </Box>
          </Box>
        </Box>
      </Box>
    </Box>
  )
}

const mapCenter = css`
  display: flex;
  align-items: center;
  justify-content: center;
`

const emptyMapContent = css`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
  color: rgba(0, 0, 0, 0.38);
`

const mapIcon = css`
  font-size: 48px;
  opacity: 0.4;
`

const mapTitle = css`
  font-weight: 500;
`

const mapCaption = css`
  opacity: 0.7;
`

const sidePanelCenter = css`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 16px;
  padding: 48px 16px;
  text-align: center;
`

const errorIcon = css`
  font-size: 40px;
  opacity: 0.5;
`

const messageText = css`
  line-height: 1.6;
`
